// firebase
import { db } from "config/firebase";
import { doc, getDoc } from "firebase/firestore";

// features/user
import getUserContacts from "features/user/getUserContacts";

// A ---------------------------------------------------------------------- M

const getRequest = async (id) => {
  try {
    const reqRef = doc(db, "recordsdata", id);
    const req = await getDoc(reqRef);

    if (req.exists()) {
      const data = req.data();
      const creator_uuid = data.creator_uuid || "N/A";

      let creator;

      if (creator_uuid) {
        try {
          const creatorContacts = await getUserContacts(creator_uuid);
          if (creatorContacts.email) {
            creator = creatorContacts.email;
          } else {
            creator = creator_uuid;
          }
        } catch (error) {
          console.error("Unable to fetch creator:", error);
        }
      } else {
        creator = "N/A";
      }

      return {
        id,
        creator_email: creator,
        ...data,
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error in getRequest:", error);
    return null;
  }
};

export default getRequest;
